export default __webpack_public_path__ + "36acbffa2bc592600533042ca1be50b0.png";